<template>
  <div class="order-card">
    <div class="order-header" @click="toggle">
      <input
        type="checkbox"
        v-model="order.selected"
        @click.stop
      />
      <div class="info">
        <strong v-if="!order.isEdit">依頼番号 : {{ order.requestNo }}</strong>
        <strong v-else class="input-edit" @click.stop>
          <span>依頼番号 <span class="text-danger">*</span> : </span>
          <input type="text" class="form-control" :class="{ 'bg-input-error': !validateRequestNo() }" v-model="order.requestNo">
        </strong>
        <strong v-if="!order.isEdit">出荷名 : {{ order.shippingName }}</strong>
        <strong v-else class="input-edit" @click.stop>
          <span>出荷名<span class="text-danger">*</span> : </span>
          <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shippingName }" v-model="order.shippingName">
        </strong>
      </div>
      <div>出荷予定個数合計：{{ calcTotalQuantity(order.products) }}</div>
      <span v-if="order.valid" class="status valid">成功</span>
      <span v-else class="status error">エラー</span>
      <button class="btn mr-l-10 w-50" @click.stop="editShipping()">
        <i class="fa" :class="order.isEdit ? 'fa-floppy-o' : 'fa-pencil-square-o' " aria-hidden="true"></i>
      </button>
      <button class="btn mr-l-10 w-50" @click.stop="deleteShipping()">
        <i class="fa fa-trash" aria-hidden="true"></i>
      </button>
    </div>
    <div v-if="expanded" class="order-body">
      <div style="display: flex; gap: 20px;">
        <div class="section">
          <h4>基本情報入力</h4>
          <div v-if="order.isEdit">
            <div class="input-edit">
              <b>発送元名<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shipment.name }" v-model="order.shipment.name">
            </div>
            <div class="input-edit">
              <b>郵便番号<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shipment.postalCode }" v-model="order.shipment.postalCode">
            </div>
            <div class="input-edit">
              <b>都道府県<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shipment.prefecture }" v-model="order.shipment.prefecture">
              <b>住所1<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shipment.address1 }" v-model="order.shipment.address1">
            </div>
            <div class="input-edit">
              <b>住所2: </b>
              <input type="text" class="form-control" v-model="order.shipment.address2">
            </div>
            <div class="input-edit">
              <b>電話番号<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.shipment.phoneNo }" v-model="order.shipment.phoneNo">
            </div>
          </div>
          <div v-else>
            <div><b>発送元名: </b>{{ order.shipment.name }}</div>
            <div>
              <b>郵便番号: </b>{{ order.shipment.postalCode }}
            </div>
            <div>
              <b>都道府県: </b>{{ order.shipment.prefecture }}
              <b>住所1: </b>{{ order.shipment.address1 }}
            </div>
            <div v-if="order.shipment.address2">
              <b>住所2: </b>{{ order.shipment.address2 }}
            </div>
            <div><b>電話番号: </b>{{ order.shipment.phoneNo }}</div>
          </div>
        </div>
        <div class="section">
          <h4>お届け先情報入力</h4>
          <div v-if="order.isEdit">
            <div class="input-edit">
              <b>お届け先名<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.delivery.name }" v-model="order.delivery.name">
            </div>
            <div class="input-edit">
              <b>郵便番号<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.delivery.postalCode }" v-model="order.delivery.postalCode">
            </div>
            <div class="input-edit">
              <b>都道府県<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.delivery.prefecture }" v-model="order.delivery.prefecture">
              <b>住所1<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.delivery.address1 }" v-model="order.delivery.address1">
            </div>
            <div class="input-edit">
              <b>住所2: </b>
              <input type="text" class="form-control" v-model="order.delivery.address2">
            </div>
            <div class="input-edit">
              <b>電話番号<span class="text-danger">*</span>: </b>
              <input type="text" class="form-control" :class="{ 'bg-input-error': !order.delivery.phoneNo }" v-model="order.delivery.phoneNo">
            </div>
          </div>
          <div v-else>
            <div><b>お届け先名: </b>{{ order.delivery.name }}</div>
            <div>
              <b>郵便番号: </b>{{ order.delivery.postalCode }}
            </div>
            <div>
              <b>都道府県: </b>{{ order.delivery.prefecture }}
              <b>住所1: </b>{{ order.delivery.address1 }}
            </div>
            <div v-if="order.delivery.address2">
              <b>住所2: </b>{{ order.delivery.address2 }}
            </div>
            <div><b>電話番号: </b>{{ order.delivery.phoneNo }}</div>
          </div>
        </div>
      </div>
      <div v-if="order.isEdit" class="text-danger">(*) 必須項目</div>
      <div class="section">
        <h4>商品情報入力</h4>
        <button v-if="order.isEdit" type="button" class="btn btn-primary mr-b-10" @click="openModalProductAdd">商品選択</button>
        <table>
          <thead>
            <tr>
              <th>出荷する商品</th>
              <th>在庫数</th>
              <th>出荷予定数</th>
              <th v-if="order.isEdit"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, index) in order.products" :key="index">
              <td class="flexbox gap-10" style="flex-wrap: nowrap;">
                <div v-if="p.image">
                  <img :src="p.image" width="75">
                </div>
                <div>
                  <div>
                    {{ p.itemName }}
                  </div>
                  <div class="flexbox gap-10">
                    <span><b>ASIN:</b>{{ p.asin }}</span>
                    <span><b>SKU:</b>{{ p.sku }}</span>
                  </div>
                  <div class="flexbox gap-10">
                    <span><b>商品ID:</b>{{ p.itemId }}</span>
                    <span><b>商品ラベル:</b>{{ p.goodsLabel }}</span>
                  </div>
                </div>
              </td>
              <td>
                {{ p.scQuantity }}個
              </td>
              <td>
                <div v-if="order.isEdit" class="input-edit">
                  <input type="number" class="form-control w-100" :class="{ 'bg-input-error': !p.quantity || p.quantity <= 0 }" v-model="p.quantity" min="1" />個
                </div>
                <span v-else>{{ p.quantity }}個</span>
              </td>
              <td v-if="order.isEdit">
                <div class="text-center">
                  <button type="button" class="btn btn-delete-selected-product" @click="handleDelete(p)">削除</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="section">
        <h4>配送方法入力</h4>
        <div class="radio-group">
          <div class="radio-option" :class="{ 'selected': order.transporterCode == '1004'}">
            <label>
              <input type="radio" value="1004" v-model="order.transporterCode">  ネコポス
            </label>
          </div>
          <div class="radio-option" :class="{ 'selected': order.transporterCode == '1009'}">
            <label>
              <input type="radio" value="1009" v-model="order.transporterCode">  宅配便（60サイズ以上）PE袋
            </label>
          </div>
          <div class="radio-option" :class="{ 'selected': order.transporterCode == '1001'}">
            <label>
              <input type="radio" value="1001" v-model="order.transporterCode">  宅配便（60サイズ以上）ダンボール
            </label>
          </div>
        </div>
      </div>
      <div v-if="order.errors && order.errors.length" class="error-box">
        <div v-for="(e, i) in order.errors" :key="i">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          <span v-html="e"></span>
        </div>
      </div>
    </div>
    <shipping-multi-channel-product-add
      v-if="openProductAddModal"
      ref="shippingMultiProductAddModal"
      :iconUrls="iconUrls"
      :selectedProducts="order.products"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShippingMultiChannelProductAdd from '@/view/warehouseSc/components/ShippingMultiChannelProductAdd'

export default {
  props: {
    order: Object
  },
  data () {
    return {
      expanded: false,
      openProductAddModal: false
    }
  },
  computed: {
    ...mapGetters({
      iconUrls: 'getWareHouseIcons'
    })
  },
  components: {
    ShippingMultiChannelProductAdd
  },
  methods: {
    toggle () {
      this.expanded = !this.expanded
    },
    validateRequestNo () {
      if (!this.order.requestNo) {
        return true
      }
      const regex = /^[a-zA-Z0-9-ｰー]{1,100}$/
      if (regex.test(this.order.requestNo)) {
        return true
      } else {
        return false
      }
    },
    openModalProductAdd () {
      this.openProductAddModal = true
    },
    closeModalProductAdd () {
      $('#shipping-product-add-modal').modal('hide')
      this.openProductAddModal = false
    },
    calcTotalQuantity (products) {
      return products.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0)
    },
    editShipping () {
      this.order.isEdit = !this.order.isEdit
      if (this.order.isEdit) {
        this.expanded = true
      } else {
        this.$emit('validateAll')
      }
    },
    deleteShipping () {
      this.$emit('deleteShipping', this.order)
    },
    handleSelectedProduct (product) {
      this.order.products = [...this.order.products, product]
    },
    handleSelectedProducts (products) {
      this.order.products = [...this.order.products, ...products]
    },
    handleDelete (product) {
      this.order.products = this.order.products.filter(item => item.itemId !== product.itemId)
    }
  }
}
</script>

<style scoped>
.order-card {
  border: 1px solid #ddd;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
}

.order-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #fafafa;
  cursor: pointer;
}

.order-header .info {
  flex: 1;
  margin-left: 10px;
  display: flex;
  gap: 20px;
  align-items: center;
  .input-edit {
    margin-bottom: unset;
  }
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  min-width: 70px;
  text-align: center;
}

.valid {
  background: #d4edda;
  border-color: #28a745;
  color: #155724;
}

.error {
  background: #f8d7da;
  border-color: #dc3545;
  color: #721c24;
}

.edit {
  background: #ccc;
  color: #fff;
}

.order-body {
  padding: 15px;
  background: white;
}

.section {
  margin-bottom: 15px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 6px;
  min-width: 120px;
}

.error-box {
  background: #fff3cd;
  padding: 10px;
  border-radius: 6px;
  color: red;
}

.input-edit {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  margin-bottom: 10px;
  b {
    min-width: 80px;
  }
  .form-control {
    background-color: #c9f8d4;
  }
  .bg-input-error {
    background-color: #fdefef !important;
  }
}

.btn-delete-selected-product {
  background-color: #ffffff;
  border: 1px solid #a94442;
  color: #a94442;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/OrderCard.vue